import axios from "axios";
import { CONFIG } from "../../config";

const BASE_URL = CONFIG.baseApiUrl;

// Create an Axios instance with default configuration
const instance = axios.create({
  baseURL: BASE_URL, // Replace with your API base URL
  timeout: 10000, // Timeout in milliseconds
  headers: {
    "Content-Type": "application/json",
    "x-region": "Asia/Kolkata"
  }
});

instance.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log("Axios error:", error?.response?.data ?? error);
    const response = error?.response?.data || AxiosError;
    if (response?.code === 400) {
      return { data: response };
    }
    return Promise.reject(response);
  }
);

export const Get = async (url, config) => {
  const response = await instance.get(url, config);
  return response.data;
};

export const Post = async (url, data, config) => {
  const response = await instance.post(url, data, config);
  return response.data;
};

const AxiosError = {
  code: 500,
  message: 'Something went wrong. Please try again later.',
  description: 'Axios Error'
}
